// @todo: lazy loading
// @todo: create an endpoint to serve the right picture in the right size and
// other data

const close_modal = (dialog, backdrop) => {
    backdrop.classList.remove('active');
    dialog.classList.remove('active')

    setTimeout(() => {
        dialog.parentNode.removeChild(dialog)
        backdrop.parentNode.removeChild(backdrop)
    }, 500);

    return undefined;
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.media > img').forEach(image => {
        image.addEventListener('click', event => {
            let backdrop = document.createElement('div');
            backdrop.className = 'backdrop shadow active';
            document.body.appendChild(backdrop);

            let wrapper = document.body.querySelector('main > div.container .wrapper');
            let wrapper_rect = wrapper.getBoundingClientRect();

            let dialog = document.createElement('div');
            dialog.className = 'dialog active';
            dialog.style.width = `${wrapper_rect.width}px`;
            // dialog.style.top = `${wrapper_rect.y}px`;
            dialog.style.position = 'fixed';

            window.addEventListener('resize', () => {
                wrapper_rect = wrapper.getBoundingClientRect();
                dialog.style.width = `${wrapper_rect.width}px`;
            })

            let close = document.createElement('i');
            close.className = 'close';
            close.innerHTML = '&#10005;';
            close.addEventListener('click', () => {
                return close_modal(dialog, backdrop);
            })
            dialog.appendChild(close);

            let img = document.createElement('img');
            img.src = image.src.replace(/\/(\d{0,3}x\d{0,3})\//, '\/650x650\/');
            img.className = 'img-fluid'

            if ('permalink' in image.dataset) {
                console.log(image.src)
                if (image.src.match(/\/media\/images\//)) {
                    img.src = image.dataset.permalink;
                } else {
                    let anchor = document.createElement('a')
                    anchor.className = 'rkd_database';
                    anchor.innerHTML = trans.dialog.show_in_rkd_db.toUpperCase();
                    anchor.target = '_blank';
                    anchor.href = image.dataset.permalink;
                    dialog.appendChild(anchor);
                }
            }

            dialog.appendChild(img);
            wrapper.appendChild(dialog);

            backdrop.addEventListener('click', () => {
                return close_modal(dialog, backdrop);
            })

            return undefined;
        })
    })
})
